<template>
    <span :key="val" v-if="escape" v-bind="options">{{text}}</span>
    <span :key="val" v-else v-bind="options" v-html="text"></span>
</template>


<script>
    export default {
        props: {
            val: {
                required: true
            },
            escape: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: "values",
            },
            args: {}
        },
        data: function () {
            return {
                text: i18nInner(this.type, this.val, this.args)
            }
        },
        mounted: function () {
            this.$root.$on('locale', () => this.text = i18nInner(this.type, this.val, this.args));
        },
        computed: {
            options() {
                return this.type === "values" ? {[`i18n`]: this.val} : {}
            }
        },
        watch: {
            val: function () {
                this.text = i18nInner(this.type, this.val, this.args)
            }
        }
    };
</script>